module.exports = __webpack_public_path__ + "static/media/game_cover_baseball.5f0cbc45.png";